// Territory — canonical values, presentation and normalisation helpers.
// Canonical backend values: "UK" | "EUROPE" | "UAE" | "US" | null.
// Flags are UI-only. Never store emoji as the canonical value.

export const TERRITORY_VALUES = ["UK", "EUROPE", "UAE", "US"];

export const TERRITORY_META = {
  UK:     { flag: "🇬🇧", label: "UK",     short: "UK" },
  EUROPE: { flag: "🇪🇺", label: "EUROPE", short: "EU" },
  UAE:    { flag: "🇦🇪", label: "UAE",    short: "UAE" },
  US:     { flag: "🇺🇸", label: "US",     short: "US" },
};

export function territoryFlag(value) {
  return TERRITORY_META[value]?.flag || "";
}

export function territoryLabel(value) {
  if (!value) return "NOT SET";
  return TERRITORY_META[value]?.label || value;
}

export function territoryShort(value) {
  if (!value) return "NOT SET";
  return TERRITORY_META[value]?.short || value;
}

// Full options for dropdowns (Add/Edit Client).
export const TERRITORY_OPTIONS = [
  { value: "",       label: "— Not set —"           },
  { value: "UK",     label: "🇬🇧  UK"               },
  { value: "EUROPE", label: "🇪🇺  EUROPE"           },
  { value: "UAE",    label: "🇦🇪  UAE"              },
  { value: "US",     label: "🇺🇸  US"               },
];

// Filter options (Clients list).
export const TERRITORY_FILTER_OPTIONS = [
  { value: "",         label: "All territories"     },
  { value: "UK",       label: "🇬🇧  UK"             },
  { value: "EUROPE",   label: "🇪🇺  EUROPE"         },
  { value: "UAE",      label: "🇦🇪  UAE"            },
  { value: "US",       label: "🇺🇸  US"             },
  { value: "NOT_SET",  label: "Not set"             },
];
